import { Flex, Text } from "@chakra-ui/react";
import { Star } from "@airhelp/icons";

export function Motivator({ text }: { text: string }) {
  return (
    <Flex
      p={4}
      bg="rgba(13, 48, 115, 0.56)"
      backdropFilter="blur(16px)"
      borderRadius="lg"
      color="greyscale.100"
      gap={4}
      alignItems="center"
      w="312px"
      maxW="none"
      position="absolute"
      right="calc(100% - 375px)"
      top="calc(100% - 300px)"
      sx={{
        "@media(height<824px)": { display: "none" },
        "@media(width<1280px)": { display: "none" },
      }}
    >
      <Star color="greyscale.100" boxSize={6} />
      <Text color="greyscale.100" fontWeight="bold" fontSize="sm">
        {text}
      </Text>
    </Flex>
  );
}
